import React from 'react'
import HomeAbout from '../component/HomeAbout'
import BannerBottom from '../component/BannerBottom'
import aboutTop from '../assets/about-pages/ep_about_banner.webp'
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import RadarOutlinedIcon from '@mui/icons-material/RadarOutlined';


export default function About() {
    return (
        <>
            <div className='ms-hero-banner-sec' style={{ paddingTop: '80px' }}>
                <div className="container">
                    <div className='row  align-items-center'>
                        <div className='col-lg-6'>
                            <div className='ms-banner-heading'>
                                <span className='ms-takeaways'> 24/7 Support</span>
                                {/* <h1>Wallet Loaded Instantly1</h1> */}
                                <h1 className='fs-1 pt-3 fw-semibold'>Wallet Loaded Instantly </h1>
                                <p className='fw-lighter fs-5 pt-3'>From a few clicks to fast cash, we’re on our toes 24*7*365 to help you with instant funds in just 10 minutes.</p>
                            </div>
                        </div>
                        <div className='col-lg-6'>
                            <img src={aboutTop} alt='EP' className='img-fluid' style={{marginTop:'30'}}/>
                        </div>
                    </div>
                </div>
            </div>
             <BannerBottom />
            <HomeAbout />
            <div className='ms-vision-mission ms-bg-primary'>
                <div className='fluid-container'>
                    <div className='col-lg-12'>
                        <div className="row d-flex" style={{borderBottom:'1px solid rgb(255 255 255 / 27%)'}}>
                        <div className='col-lg-6 align-content-center p-5'>
                            {/* <h3 className='text-white text-uppercase fw-normal'> 
                                <RemoveRedEyeOutlinedIcon style={{fontSize:'60px'}}/> Our Vision</h3> */}
                            <p className='text-white' style={{lineHeight:'30px'}}>Modern expenses require quick, reliable and innovative monetary solutions—all without having to step out of the comfort zone. Therefore, we endeavour to provide lightning-fast personal loan services, backed by the use of progressive technology and the invaluable experience of highly skilled digital lending specialists. We aim to pave the way for a brighter future by providing a reliable financial backup, enabling you to trust us in times of financial need. With us, you gain an extra layer of economic security, ensuring that you and your loved ones always feel at ease and remain financially secure. </p>
                        </div>
                        <div className='col-lg-6 order-last' style={{borderLeft:'1px solid rgb(255 255 255 / 27%)'}}>
                        <div className='text-center text-white p-5 '>
                             <RemoveRedEyeOutlinedIcon style={{fontSize:'160px'}}/> <br/>
                                 <h4 className='text-uppercase font-style1'> Our Vision</h4>
                        </div>
                           
                       
                            {/* <img className='d-block' src={visionImg} alt='' style={{width:'60%', margin:'0 auto'}}/> */}
                        </div>
                        
                    </div>
                     <div className="row d-flex">
                         <div className='col-lg-6' style={{borderRight:'1px solid rgb(255 255 255 / 27%)'}}>
                         <div className='text-center text-white p-5'>
                             <RadarOutlinedIcon style={{fontSize:'160px'}}/> <br/>
                                 <div className='text-uppercase font-style1'> Our Mission</div>
                        </div>
                             {/* <img className='d-block' src={visionImg} alt='' style={{width:'60%', margin:'0 auto'}}/> */}
                        </div>
                        <div className='col-lg-6 align-content-center p-5'>
                           
                            <p className='text-white' style={{lineHeight:'30px'}}>Our mission at Udhaarpaisa  has been clear from the outset: to empower salaried individuals financially, enabling them to focus solely on building their future without being hindered by today’s financial constraints. Whether it's a mid-month cash crunch, a month-end misery, an unexpected expense, or the need for extra funds, we want to stand tall with them, extending a helping hand and paving the way to a stress-free life. We endeavour to redefine modern borrowing practices by offering personal loans at a remarkable speed and with complete transparency, so that every individual, whether a first-time applicant or an experienced borrower, can entirely rely on the fintech industry without hesitation.</p>
                        </div>
                       
                        
                    </div>
                    </div>
                    
                </div>
            </div>
            {/* <WhyChoose /> */}
           
            {/* <div style={{background:(`url(${bgWave})`), backgroundSize:'100%', padding:'100px 0'}}>dsdasdasd</div> */}
            {/* <div className='ms-hero-banner-sec' style={{ height:'10px'}}></div> */}
            {/* <img src={bgWave} alt='' className='' style={{marginTop:'-10px', transform:'rotate(180deg)', height:'200px', width:'100%'}}/> */}





        </>
    )
}
